import {
  type GenerateStyle,
  genComponentStyleHook,
  type FullToken,
} from "antd/es/theme/internal";
import { ratePrefixCls } from "@/base/components/rate/Rate.component";
import { THEME_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Rate">> = ({ starSizeLG }: any) => ({
  [`.${THEME_PREFIX}`]: {
    [`&.${ratePrefixCls}`]: {
      [`&.${ratePrefixCls}-size-large`]: {
        fontSize: `${starSizeLG}px`,
      },
    },
  },
});

export const useRateStyle = genComponentStyleHook(["Rate", "cso"], (token) => {
  return [genStyle(token)];
});
